import {
  Box,
  Button,
  CompassColor,
  Stack,
  Text,
  VariantColor,
} from "@noom/wax-component-library";

export const PROFILE_LOAD_ERROR_MESSAGE =
  "We couldn't load your account information. Please try again.";

/**
 * Blocking error shown when the post-auth patient-profile fetch fails for a
 * transient (non-400/404) reason.
 *
 * Pre hive-auth migration the profile was fetched as part of login/in-app auth,
 * so a failure kept the user out of gated pages entirely (they never rendered
 * without a profile). This restores that invariant: rather than letting a gated
 * page render with a null profile, we surface a retryable error. A reload is
 * enough to retry because the provider never caches the `error` state, so it
 * re-fetches `/v1/patient/` on the next load.
 */
type ProfileLoadErrorProps = {
  onRetry?: () => void;
};

export const ProfileLoadError = ({ onRetry }: ProfileLoadErrorProps) => (
  <Box
    data-cy="profile-load-error"
    minH="100vh"
    display="flex"
    alignItems="center"
    justifyContent="center"
    p={6}
  >
    <Stack spacing={4} maxWidth="360px" textAlign="center" alignItems="center">
      <Text fontSize="18px" color={CompassColor.black}>
        {PROFILE_LOAD_ERROR_MESSAGE}
      </Text>
      <Button
        variantColor={VariantColor.primary}
        color={CompassColor.white}
        onClick={onRetry ?? (() => window.location.reload())}
      >
        Try again
      </Button>
    </Stack>
  </Box>
);
